import { descriptionIsConsideredSufficient } from "./validateQuality/description";

export function filterViableDescriptions(
  descriptionItems: { value: string; id: string }[]
) {
  return descriptionItems.filter((descriptionItem) =>
    descriptionIsConsideredSufficient(descriptionItem.value)
  );
}
